// Passo a passo de cada integração (aba em Administração → Integrações). O texto mora em
// src/docs/guias (fonte única, também aparece na Central de ajuda); as redes sociais usam a seção
// correspondente do guia geral das redes, sem duplicar texto.

export interface IntegrationGuideRef {
  /** Arquivo em src/docs (como o DOCS o identifica). */
  file: string;
  /** Início do título "## ..." da seção a mostrar; ausente = o documento inteiro. */
  section?: string;
}

export const SOCIAL_GUIDE = './guias/configurar-redes.md';

export const INTEGRATION_GUIDES: Record<string, IntegrationGuideRef> = {
  blob_storage: { file: './guias/integracoes/blob-storage.md' },
  landing_pages: { file: './guias/integracoes/landing-pages.md' },
  onedrive_graph: { file: './guias/integracoes/onedrive-graph.md' },
  crm_grpc: { file: './guias/integracoes/crm-grpc.md' },
  image_converter: { file: './guias/integracoes/conversor-imagens.md' },
  anthropic_admin: { file: './guias/integracoes/anthropic-admin.md' },
  openai_admin: { file: './guias/integracoes/openai-admin.md' },
  social_workflow: { file: './guias/integracoes/fluxo-dos-posts.md' },
  meta: { file: SOCIAL_GUIDE, section: '## 1. Meta' },
  pinterest: { file: SOCIAL_GUIDE, section: '## 2. Pinterest' },
  tiktok: { file: SOCIAL_GUIDE, section: '## 3. TikTok' },
  google_youtube: { file: SOCIAL_GUIDE, section: '## 4. YouTube' },
  canva: { file: './guias/integracoes/canva.md' },
  unsplash: { file: './guias/integracoes/unsplash.md' },
  pexels: { file: './guias/integracoes/pexels.md' },
};

/** Tira o título principal (# ...), que já aparece na tela. */
export const stripTitle = (body: string): string => body.replace(/^#\s+.*\n+/, '');

/**
 * Recorta a seção que começa no título indicado e vai até o próximo "## " (ou separador "---").
 * Vazio quando o título não existe.
 */
export const extractSection = (body: string, heading: string): string => {
  const lines = body.replace(/\r\n/g, '\n').split('\n');
  const start = lines.findIndex((l) => l.startsWith(heading));
  if (start < 0) return '';
  let end = lines.length;
  for (let i = start + 1; i < lines.length; i++) {
    if (lines[i].startsWith('## ') || lines[i].trim() === '---') {
      end = i;
      break;
    }
  }
  return lines.slice(start, end).join('\n').trim();
};

/** Passo a passo de cada propósito em IA — Provedores (fornecedor padrão de cada um). */
export const AI_PROVIDER_GUIDES: Record<string, IntegrationGuideRef> = {
  vision: { file: './guias/integracoes/anthropic-chave-api.md' },
  copywriting: { file: './guias/integracoes/anthropic-chave-api.md' },
  landing: { file: './guias/integracoes/anthropic-chave-api.md' },
  embedding: { file: './guias/integracoes/openai-chave-api.md' },
};

/** Texto do passo a passo de um propósito de IA (vazio se não houver guia). */
export const aiProviderGuideText = (purpose: string, docs: { file: string; body: string }[]): string => {
  const ref = AI_PROVIDER_GUIDES[purpose];
  const doc = ref && docs.find((d) => d.file === ref.file);
  return doc ? stripTitle(doc.body) : '';
};

/** Texto do passo a passo da integração (vazio se não houver guia). */
export const integrationGuideText = (key: string, docs: { file: string; body: string }[]): string => {
  const ref = INTEGRATION_GUIDES[key];
  if (!ref) return '';
  const doc = docs.find((d) => d.file === ref.file);
  if (!doc) return '';
  if (!ref.section) return stripTitle(doc.body);
  const section = extractSection(doc.body, ref.section);
  if (!section) return '';
  return `${section}\n\n> Antes, veja **Antes de tudo** (política de privacidade, termos de uso, ícone e endereços de retorno) no [guia completo das redes](/help?doc=${SOCIAL_GUIDE}).`;
};
